import React, { FC } from 'react';
import classNames from 'classnames';
import IconTemplate, { IconType } from '@ui-components/icon-template';

import './taskDetailsRailLeftNavigationItem.scss';

interface Props {
  handleClick: () => void;
  navigationVisible: boolean;
  iconName: IconType;
  label: string;
  className?: string;
  notificationCount?: number;
  height?: number;
  width?: number;
  id: string | number;
  selected?: boolean;
  isToggleItem?: boolean;
}

const TaskDetailsRailLeftNavigationItem: FC<Props> = ({
  handleClick,
  iconName,
  navigationVisible,
  label,
  className,
  notificationCount = 0,
  width = 20,
  height = 20,
  id,
  selected = false,
  isToggleItem = false
}) => {
  const navigationItemsClassNames = classNames('ui-components-task-details-rail-left-item', {
    [`${className}`]: className,
    'ui-components-task-details-rail-left-item_selected': selected,
    'ui-components-task-details-rail-left-toggle': isToggleItem
  });

  return (
    <div
      className={navigationItemsClassNames}
      onClick={handleClick}
      id={`TaskDetailsRailLeftNavigationItem${id}`}
    >
      <div className="ui-components-task-details-rail-left-item_icon">
        <IconTemplate name={iconName} color="grey-dark" pointer width={width} height={height} />
        {notificationCount > 0 && (
          <div
            id={`unreadCountSegmentIcon${label.replace(/\s/g, '')}`}
            className="ui-components-task-details-rail-left-item_notification-count"
          ></div>
        )}
      </div>
      {navigationVisible && (
        <p className="ui-components-task-details-rail-left-item_label">{label}</p>
      )}
    </div>
  );
};

export default TaskDetailsRailLeftNavigationItem;
